import { routes } from 'src/constants/routes'

export const PURCHASE_REMINDER_COOKIE = 'purchase_reminder'
export const COOKIE_INTERVAL_CHECK = 5000
export const PURCHASE_REMINDER_COOKIE_DAYS_EXPIRES = 1
export const PURCHASE_REMINDER_PAGES_TO_DISPLAY = [routes.list.pathname, routes.detail.pathname]
